import { createAction } from 'redux-act'
import { fetch } from 'actions/locales'

export const switchLocale = createAction('ui/switchLocale')
export const toggleHowItWorks = createAction('ui/toggleHowItWorks')

export const fetchAndSwitchLocale = (locale) => (dispatch) => {
  dispatch(switchLocale({ locale }))
  return dispatch(fetch(locale))
}
